(ns splash.ui.lender-portal.components.application-banner
  (:require
    [reagent.core :as r]
    [splash.ui.lender-portal.common.util :as util]
    [splash.ui.lender-portal.components.mui :as mui]))

(defn banner-item
  [title value]
  [mui/list
   [mui/list-item {:sx {:py 0}}
    [mui/typography {:sx {:fontWeight 600
                          :fontSize "14px"}} title]]
   [mui/list-item {:sx {:py 0}}
    [mui/typography {:sx {:fontWeight 400
                          :fontSize "14px"}} (if (nil? value)
                                               "-"
                                               value)]]])

(defn banner-divider
  []
  [mui/divider {:orientation :vertical
                :flexItem    true
                :variant     :middle
                :light       true
                :sx {:border-color "rgba(102, 102, 102, 1)"}}])

(defn application-banner
  [current-application]
  (.log js/console @current-application)
  (r/with-let [{:keys [application-id
                       first-name
                       last-name
                       product-type
                       final-loan-amount
                       original-loan-amount
                       success-status
                       submitted-at
                       closed-date
                       approved-date
                       denied-date
                       expired-date]} @current-application
               format-date (fn [d]
                             (when d
                               (-> d
                                 util/string->datetime
                                 util/->to-local
                                 util/datetime->date-string)))]
    [mui/stack {:direction :row
                :justifyContent :space-around
                :alignItems :center
                :sx {:backgroundColor "rgba(31,31,31,1)"
                     :height "64px"
                     :width "100%"
                     :color "white"}}
     [banner-item "Application ID" application-id]
     [banner-item "Borrower Name" (str first-name " " last-name)]
     [banner-divider]
     [banner-item "Product Type" product-type]
     [banner-item "Loan Amount" (str "$ " (or final-loan-amount original-loan-amount))]
     [banner-item "Application Status" success-status]
     [banner-divider]
     [banner-item "Submitted Date" (format-date submitted-at)]
     [banner-item "Approved Date" (format-date approved-date)]
     (when closed-date
       [banner-item "Closed Date" (format-date closed-date)])
     (when denied-date
       [banner-item "Denied Date" (format-date denied-date)])
     (when expired-date
       [banner-item "Expired Date" (format-date expired-date)])]))
